import PropTypes from "prop-types";

import EyeSlashIcon from "@/icons/EyeSlashIcon";
import SecondaryActionButton from "@/view/SecondaryActionsToolbar/SecondaryActionButton";
import HideMobileAction from "./HideMobileAction";
import HideOptions from "./HideOptions";

const propTypes = {
  activeSubMenu: PropTypes.string,
  contentId: PropTypes.string,
  currentLevel: PropTypes.object,
  disabled: PropTypes.bool,
  hoverLabel: PropTypes.string,
  isMobile: PropTypes.bool,
  matchedAssignments: PropTypes.array,
  setActiveSubMenu: PropTypes.func,
};

const HideActionButtonWithPopout = ({
  activeSubMenu,
  contentId,
  currentLevel,
  disabled,
  hoverLabel,
  isMobile,
  matchedAssignments,
  setActiveSubMenu,
}) => {
  const actionName = "Hide";

  const eventProperties = {
    actionName,
    objectType: "Content",
    streamProperties: {
      content_id: currentLevel?.id,
      content_type: "Article",
      description: "Show hide options list",
      object_id: currentLevel?.id,
    },
  };

  const popOutContents = (
    <HideOptions
      contentId={contentId}
      currentLevelId={currentLevel?.id}
      isMobile={isMobile}
      matchedAssignments={matchedAssignments}
    />
  );

  const icon = <EyeSlashIcon />;
  const ariaProps = {
    "aria-label": "Hide",
  };

  if (isMobile) {
    return (
      <HideMobileAction
        actionName={actionName}
        activeSubMenu={activeSubMenu}
        eventProperties={eventProperties}
        disabled={disabled}
        icon={icon}
        popOutContents={popOutContents}
        setActiveSubMenu={setActiveSubMenu}
        dataProps={{ "data-qa-selector": "hide-from-classrooms" }}
      />
    );
  }

  return (
    <SecondaryActionButton
      ariaProps={ariaProps}
      disabled={disabled}
      hoverLabel={hoverLabel}
      icon={icon}
      title={actionName}
      popOutContents={popOutContents}
      eventProperties={eventProperties}
      dataProps={{ "data-qa-selector": "hide-from-classrooms" }}
    />
  );
};

HideActionButtonWithPopout.propTypes = propTypes;

export default HideActionButtonWithPopout;
